import React, { FC } from "react";

import { faCrown } from "@fortawesome/pro-solid-svg-icons/faCrown";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import Tag from "antd/es/tag";
import { defineMessages, useIntl } from "react-intl";

import Team from "@mapmycustomers/shared/types/Team";
import User, { UserRef } from "@mapmycustomers/shared/types/User";
import { AvatarWithName } from "@mapmycustomers/ui";

import UserPreviewCard from "@app/component/UserPreviewCard";
import RankDiff from "@app/scene/dashboard/components/Sidebar/components/RankDiff";
import { MetricData } from "@app/scene/dashboard/types/PerformanceData";
import { isManager, isMember, isOwner } from "@app/store/iam/util";

import styles from "./LabelCommon.module.scss";

const messages = defineMessages({
  manager: {
    id: "dashboard.sidebar.tag.manager",
    defaultMessage: "Manager",
    description: "Manager tag in Dashboard sidebar when org name is not available",
  },
  owner: {
    id: "dashboard.sidebar.tag.owner",
    defaultMessage: "Owner",
    description: "Owner tag in Dashboard sidebar when org name is not available",
  },
});

interface Props {
  performance?: MetricData;
  showRank?: boolean;
  teamId?: Team["id"];
  user: UserRef & Pick<User, "role">;
}

const UserLabel: FC<Props> = ({ performance, showRank, teamId, user }) => {
  const intl = useIntl();

  return (
    <UserPreviewCard teamId={teamId} trigger="hover" userId={user.id}>
      <div className={styles.container}>
        {!isOwner(user) && (
          <span className={styles.rank}>
            {!showRank ? (
              ""
            ) : performance?.rank === 1 ? (
              <FontAwesomeIcon className={styles.crown} icon={faCrown} />
            ) : (
              performance?.rank
            )}
          </span>
        )}
        <AvatarWithName size="xs" user={user} />
        {isOwner(user) && <Tag>{intl.formatMessage(messages.owner)}</Tag>}
        {isManager(user) && <Tag>{intl.formatMessage(messages.manager)}</Tag>}
        {isMember(user) && performance?.rankDiff && showRank ? (
          <RankDiff rankDiff={performance.rankDiff} />
        ) : null}
      </div>
    </UserPreviewCard>
  );
};

export default UserLabel;
